import { create } from "zustand";

const getInitialState = () => {
  try {
    const storedState = localStorage.getItem("token");
    if (!!storedState) {
      return true;
    }
  } catch (error) {
    console.error(
      "Erreur lors de la lecture de l'état d'authentification :",
      error
    );
  }
  return false;
};

const useAuthStore = create((set) => ({
  isLoggedIn: getInitialState(),
  login: (token) => {
    localStorage.setItem("token", token);
    set({ isLoggedIn: true });
  },
  logout: () => {
    localStorage.removeItem("token");
    set({ isLoggedIn: false });
  },
}));

export default useAuthStore;
